window.tokens = {
    zipcodeapiToken: "js-Fe9PYRFPUHYHshf6XchGJNZZMzyBU3LnWnXCMXJqg2AFYASmy13QV5PSLWQ5oQHb",
    zipcodeapiToken2: "pEBGPh30Z4HYgDhLgCHnmHGdRLVUFgTvsiLWTncixVDTMApPeH5wGnTH8Lp2JCbt"
}